<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/api/im/url'
  import Qs from 'qs'
  import download from "@/utils/download";
  let extensionList = {}
  let disposition = {"CONGESTION":"堵塞","NO ANSWER":"未应答","ANSWERED":"成功","BUSY":"忙线中"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    mounted() {
      this.dataChanage(URL.call.setting.list,{},res => {
        if (res.code == 0){
          const arr = res.result;
          for (let i in arr) {
            if (arr[i].type == 2) {
              extensionList[arr[i].content] = arr[i].content;
            }
          }
          //console.log(extensionList);
          this.formData.cols = [
            { title: '用户账号', field: 'customerNumber'},
            { title: '分机', field: 'extension',type:2,optionList: extensionList},
            { title: '手机号', field: 'mobilePhone'},
            { title: '拨打手机号', field: 'dst'},
            { title: '拨打状态', field: 'disposition',type:2,optionList: disposition},
            { title: '开始时间', field: 'startCalldate',type:5,format: 'yyyy-MM-dd HH:mm:ss'},
            { title: '结束时间', field: 'endCalldate',type:5,format: 'yyyy-MM-dd HH:mm:ss'},
            {click:"查询",auth:"call.cdr.query"},
            {click:"数据导出",auth:"call.cdr.export"},
          ]
        }
      })
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }else if (clickName == '数据导出'){
          const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
          download.exportExcel(URL.call.customercall.cdrExport,param,"用户录音数据");
        }
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
        })
      }
    },
    data () {
      return {
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.call.customercall.cdrList, //请求路径和参数
          /*selection: true,*/
          sequence: true,
          cols: [
              { title: '拨打手机号', field: 'dst'},
              { title: '分机', field: 'src'},
              { title: '拨打开始时间', field: 'calldate'},
              { title: '通话时长（秒）', field: 'duration'},
              { title: '拨打状态', field: 'disposition',render:(data,full)=>{
                return disposition[data];
                }},
              { title: '录音文件地址', field: 'recordingfile',exis:"call.cdr.down"},
              { title: '播放', field: 'recordingfile',exis:"call.cdr.down",render:(data,full)=>{
                  return "<audio controls ref='audio' class='and'><source src='"+ data +"'/></audio>";
                },width:300},
              { title: '录音下载', field: 'recordingfile',exis:"call.cdr.down",render:(data,full)=>{
                  return "<a class='el-button el-button--mini' href='"+ data +"'>下载</a>";
                }},
          ]
        }
      }
    }
  }
</script>
